import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { router } from './FullApp';
import reportWebVitals from './reportWebVitals';

import { OpenAPI } from './lib/nokapi';

import { BrowserRouter, Router, RouterProvider, createBrowserRouter } from "react-router-dom";
import { getAppRoutes } from './routes';

OpenAPI.BASE = "https://noklabs.ai";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <RouterProvider router={createBrowserRouter(getAppRoutes())} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
